import React from 'react';
import './Spacing.scss';

export const Spacing: React.FC = () => {
    return <div className="spacing"></div>;
};
